module.exports = __webpack_public_path__ + "img/fastcharger-suggestion-semipublic.c5de96ea.svg";